<template class="">
    <div class="orderView">
    <div class=" pd-20 compare-section container">
    <div class="columns">
        <div class="column is-two-thirds cart-section">
          <div class="cart-section-title">
             SHOPPING CART ({{products.length}} items)<br>
             <span class="cart-section-title-subtitle">
               Wholesale only with minimum order 1 carton (100 pcs.)
              </span>
          </div>
           <div
            class=""
            :key="index"
            v-for="(product, index) in products"
           >
                <ProductCart
                :key="index"
                :image="product.product_image[0]"
                :title="product.product_name"
                :amount="product.amount"
                :price="product.price"
                :id="product.id"
                @click="removeObj(index)"
                @update-amount="updateAmount"
                />
           </div>
        </div>
        <div class="column cart-section has-text-centered cart-section-button">
            <!-- <div class="cart-section-subtotal">
                <div class="columns is-mobile">
                    <div class="column is-6-mobile">
                        Subtotal
                    </div>
                    <div class="column is-6-mobile">
                        {{ subtotal }} THB
                    </div>
                </div>
            </div>
            <div class="cart-section-discount">
                 <div class="columns is-mobile">
                    <div class="column is-6-mobile">
                        Discount
                    </div>
                    <div class="column is-6-mobile">
                         {{ discount }} THB
                    </div>
                </div>
            </div>
            <div class="cart-section-grand-total">
                 <div class="columns is-mobile">
                    <div class="column is-6-mobile">
                        Grand total
                    </div>
                    <div class="column is-6-mobile cart-section-grand-total-amount">
                         {{ subtotal - discount }} THB
                    </div>
                </div>
            </div> -->
            <div class="">
                <b-button
                @click="gotoComfirmOrder()"
                class="has-text-black cart-section-order-button"
                >ORDER NOW</b-button>
            </div>
            <div class="">
                <b-button
                class="has-text-black cart-section-continue-shopping"
                @click="gotoProductList()"
              >
                CONTINUE SHOPPING
              </b-button>
            </div>
        </div>
    </div>
    </div>
    </div>
</template>
<script>
import ProductCart from '@/components/ProductCart.vue';
import { mapState } from 'vuex';

export default {
  name: 'ProductCompareView',
  components: {
    ProductCart,
  },
  computed: mapState({
    ProductCarts: state => state.productCart,
  }),
  data() {
    return {
      products: [],
      subtotal: 0.00,
      discount: 0.00,
      grandTotal: 0.00,
    };
  },
  created() {
    this.products = this.ProductCarts;
    console.log(this.products);
    this.say();
  },
  methods: {
    updateAmount(e) {
      this.products[e.product_index].amount = e.amountData;
      console.log(this.products);
      this.say();
    },
    say() {
      let subtotal = 0;
      let discounttotal = 0;
      this.products.forEach(item => {
        subtotal += item.amount * item.price;
        discounttotal += item.discount * item.amount;
      });

      this.subtotal = subtotal;
      this.discount = discounttotal;
    },
    removeObj(index) {
      console.log(this.products);
      this.products.splice(index, 1);
      // this.say();
      console.log(this.products);
    },
    gotoComfirmOrder() {
      this.$router.push({
        name: 'OrderConfirm',
        params: {
        },
      });
    },
    gotoProductList() {
      this.$router.push({
        name: 'ProductList',
        params: {
        },
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.orderView{
    background: #f2f2f2;
}
.cart-section{
    border: grey solid 0.5px;
    background: white;
    border-radius: 10px;
    margin:10px;
    padding:1.5rem;
    &-title{
        padding-bottom:3rem;
        font-size:20px;
        font-weight: bold;
      &-subtitle{
        font-size:20px;
        font-weight: 100;
      }
    }
    &-button{
      max-height: 240px;
    }
    &-subtotal{
        font-size: 15px;
        display: block;
        font-weight: bold;
    }
    &-discount{
        font-size: 15px;
        display: block;
        color:red;
        font-weight: bold;
    }
    &-grand-total{
        font-size: 15px;
        display: block;
        font-weight: bold;
        &-amount{
          font-size: 25px;
        }
      }
    &-order-button{
      margin-top:2rem;
      background: url("../../assets/img/home/button-menu-active.png");
      background-position: center;
      font-size: 20px;
      width:18rem;
      border:none  !important;
    }
    &-continue-shopping{
      margin-top:2rem;
      width:18rem;
      background-position: center;
      font-size: 20px;
    }
}
.compare-section{
    &-title{
        font-size:20px;
    }
}
.pd-20{
    padding: 30px;
}
.text-title{
    font-size: 30px;
}
</style>
